import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { StateService } from 'src/app/services/state.service';
import { ToastService } from 'src/app/services/toast.service';
import { TutorialsService } from 'src/app/services/tutorials.service';

import { Tutorial } from 'src/app/interfaces/tutorial';
import { FormControl, Validators } from '@angular/forms';
@Component({
  selector: 'app-tutorials-form-modal',
  templateUrl: './tutorials-form-modal.component.html',
  styleUrls: ['./tutorials-form-modal.component.scss'],
})
export class TutorialsFormModalComponent implements OnInit {
  tutorialVideo: any;
  videoSelected: boolean = false;
  loading: boolean = false;

  allowedUserTypeFormControl = new FormControl<any>(null, [
    Validators.required,
  ]);

  @Output() onCreate = new EventEmitter();

  constructor(
    private toastService: ToastService,
    private tutorialsService: TutorialsService,
    private stateService: StateService
  ) {}

  ngOnInit(): void {}

  clearAllFields() {
    this.tutorialVideo = undefined;
    this.videoSelected = false;
  }

  createTutorial() {
    this.loading = true;
    if (this.videoSelected && this.allowedUserTypeFormControl.valid) {
      const tutorial: Tutorial = {
        name: '',
        description: '',
        file: this.tutorialVideo,
        allowedUserType: this.allowedUserTypeFormControl.value as
          | 'USER'
          | 'TABLET'
          | 'USER_TABLET',
        section: 'EXERCISE',
        format: 'SHORT_VIDEO',
        sectionRelationId: this.stateService.selectedExerciseToAddTutorial!.id!,
      };

      this.tutorialsService.createTutorial(tutorial).subscribe({
        next: (response: any) => {
          this.toastService.success('Se creó correctamente el tutorial.');
          this.onCreate.emit('');
          this.loading = false;

          this.videoSelected = false;
          this.tutorialVideo = undefined;
          this.allowedUserTypeFormControl.setValue(null);

          location.reload();
        },
        error: () => {
          this.toastService.alert(
            'No se creó el tutorial, si el error persiste contactate con el soporte.'
          );
          this.loading = false;
        },
      });
    } else {
      this.toastService.alert(
        'No se creó el tutorial, debes seleccionar un video.'
      );
      this.loading = false;
    }
  }

  onVideoSelected(fileEvent: Event) {
    this.videoSelected = true;
    this.tutorialVideo = (fileEvent.target! as any).files[0];
  }
}
